import 'react-multi-carousel/lib/styles.css';
import { useExploreQuery } from '../hooks/use-explore-query';
import { ExploreOneOnOneCard } from './explore-one-on-one-card';
import styled from '@emotion/styled';
import { YellowButton } from '@/components/button/button';
import { useCallback } from 'react';
import { ExperienceSortFields, SortDirection } from '@/generated/graphql';
import { useExperienceFilter } from '../hooks/use-experience-filter';

const LoadMoreButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
`;

const PAGE_SIZE = 10;

const InPersonExperiences = () => {
  const { data, loading, fetchMore } = useExploreQuery();
  const { filter } = useExperienceFilter();
  const hasNextPage = data?.experiences?.pageInfo?.hasNextPage;
  const endCursor = data?.experiences?.pageInfo?.endCursor;

  const handleLoadMore = useCallback(() => {
    if (hasNextPage) {
      fetchMore({
        variables: {
          filter,
          sorting: {
            field: ExperienceSortFields.Next,
            direction: SortDirection.Asc,
          },
          paging: {
            first: PAGE_SIZE,
            after: endCursor,
          },
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult?.experiences?.edges?.length) {
            return previousResult;
          }

          const prevEdges = previousResult.experiences?.edges || [];
          const nextEdges = fetchMoreResult.experiences.edges || [];
          const existingIds = new Set(prevEdges.map(edge => edge?.node?.id));
          const mergedEdges = [
            ...prevEdges,
            ...nextEdges.filter(edge => !existingIds.has(edge?.node?.id)),
          ];

          return {
            ...fetchMoreResult,
            experiences: {
              ...fetchMoreResult.experiences,
              edges: mergedEdges,
            },
          };
        },
      });
    }
  }, [hasNextPage, fetchMore, filter, endCursor]);

  const experiences = (data?.experiences?.edges || []).map(edge => edge.node);

  if (loading) {
    return null; //todo - add skeleton
  } else {
    return (
      <>
        {experiences.map(experience => (
          <ExploreOneOnOneCard experience={experience} key={experience.id}></ExploreOneOnOneCard>
        ))}
        {hasNextPage && (
          <LoadMoreButtonContainer>
            <YellowButton onClick={handleLoadMore} label="Load More" />
          </LoadMoreButtonContainer>
        )}
      </>
    );
  }
};

export default InPersonExperiences;
